module.exports = __webpack_public_path__ + "static/img/cont44_08.b9dbab5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont44_08.jpg
// module id = aoD9
// module chunks = 0